import React, { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { fetchMyOrders, formatRON } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LanguageContext";
import { ext } from "@/lib/ext";

const Account = () => {
  const { user, ready, logout } = useAuth();
  const { lang } = useLang();
  const e = ext[lang];
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    if (ready && user) fetchMyOrders().then(setOrders).catch(() => setOrders([]));
  }, [ready, user]);

  if (ready && !user) return <Navigate to="/login" replace />;

  return (
    <main className="mx-auto max-w-3xl px-4 py-10 sm:px-6" data-testid="account-page">
      <div className="mb-8 flex items-center justify-between">
        <div>
          <h1 className="text-2xl uc font-semibold sm:text-3xl">{e.myOrders}</h1>
          <div className="mt-1 font-mono text-[11px] uppercase tracking-widest text-muted-foreground">{user?.email}</div>
        </div>
        <button data-testid="account-logout" onClick={() => { logout(); navigate("/"); }} className="border border-border px-4 py-2 font-mono text-[11px] uppercase tracking-widest hover:bg-foreground hover:text-white">{e.logout}</button>
      </div>

      {orders.length === 0 ? (
        <p className="font-mono text-xs uppercase tracking-widest text-muted-foreground">{e.noOrders}</p>
      ) : (
        <div className="space-y-3">
          {orders.map((o) => (
            <div key={o.id} className="border border-border p-4" data-testid={`account-order-${o.order_number}`}>
              <div className="flex items-center justify-between">
                <span className="font-mono text-xs uppercase tracking-widest">{o.order_number}</span>
                <span className="border border-foreground px-2 py-0.5 font-mono text-[10px] uppercase tracking-widest">{e.status[o.status] || o.status}</span>
              </div>
              <div className="mt-2 font-mono text-[11px] uppercase tracking-widest text-muted-foreground">
                {o.items.map((i) => `${i.name} ×${i.qty}`).join(" · ")}
              </div>
              <div className="mt-2 text-right font-mono text-sm">{formatRON(o.total)}</div>
            </div>
          ))}
        </div>
      )}
    </main>
  );
};

export default Account;
